import { gql, useLazyQuery } from "@apollo/client";
import { useContext, useEffect, useState } from "react";
import { ContextUser } from "src/context/ContextUser";
import { ChatChannel } from "src/graphql/codegen_graphql";
import useChannel from "./useChannel";

const QUERY_CHAT_CHANNEL_LIST = gql`
  query ChatChannelList {
    chatChannelList {
      onlineStatus
      name
      image
      channel
      lastMessageAt
      lastMessage {
        text
        attachments {
          type
          src
          lat
          lng
        }
        packageId
        productId
        product {
          id
          code
          price
          title
          thumbnail
          discount
        }
      }
      unread
      lastSeenMessageAt
      lastMessageEntity {
        id
        name
        image
      }
    }
  }
`;

export default function useChatChannelList() {
  const { merchant } = useContext(ContextUser);
  const [loading, setLoading] = useState<boolean>(true);
  const [list, setList] = useState<ChatChannel[]>([]);
  const [getChatChannelList, { loading: refreshing }] = useLazyQuery<{ chatChannelList: ChatChannel[] }>(
    QUERY_CHAT_CHANNEL_LIST,
    {
      onCompleted: (r) => {
        loading && setLoading(false);
        const channels = [...(r.chatChannelList || [])];
        channels.sort((a, b) => Number(b.lastMessageAt || 0) - Number(a.lastMessageAt || 0));
        setList(channels);
      },
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
    },
  );
  const { list: listCustomerService } = useChannel(Number(2000000000) + Number(merchant.id ?? 0) + "_3000000000");

  useEffect(() => {
    getChatChannelList();
  }, [getChatChannelList]);

  const onRefresh = () => {
    getChatChannelList();
  };

  const customerService = listCustomerService[0];

  return {
    list: [
      {
        onlineStatus: "",
        name: "Customer Service",
        image: "https://ui-avatars.com/api/?name=Customer+Service&background=f368e0&color=ffffff&bold=true",
        channel: customerService ? customerService.channel : "",
        lastMessageAt: customerService ? customerService.createdAt : "",
        lastMessage: customerService ? customerService.message : null,
        unread: 1,
        lastSeenMessageAt: null,
        lastMessageEntity: customerService ? customerService.sender : {},
      },
      ...list,
    ],
    setList,
    loading,
    refreshing,
    onRefresh,
  };
}
